export default "__VITE_ASSET__CJ0d6auC__"